import { defineComponent as e, createBlock as r, openBlock as i, Transition as t, withCtx as m, createElementBlock as p, createCommentVNode as n, normalizeClass as a, createVNode as l, unref as s } from "vue";
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
import { _ as c } from "./UiIcon.vue_vue_type_script_setup_true_lang-BEUNoCyM.js";
/* empty css                                                */
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import "../config/index.js";
/* empty css                                                           */
/* empty css                                                       */
/* empty css                                                   */
/* empty css                                                  */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                    */
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const J = /* @__PURE__ */ e({
  __name: "UiLoading",
  props: {
    isShow: { type: Boolean },
    iconName: { default: "progress-activity" },
    iconSize: { default: "md" },
    iconType: { default: "100" },
    iconColor: {},
    filled: { type: Boolean }
  },
  setup(d) {
    return (o, f) => (i(), r(t, { name: "fade" }, {
      default: m(() => [
        o.isShow ? (i(), p("div", {
          key: 0,
          class: a(["ui-loading", { "is-filled": o.filled }])
        }, [
          l(s(c), {
            type: o.iconType,
            name: o.iconName,
            color: o.iconColor,
            size: o.iconSize
          }, null, 8, ["type", "name", "color", "size"])
        ], 2)) : n("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  J as _
};
